import React from 'react';

import i18n from '@client/utils/i18n';
import { generateUniqueName } from '@ledium/ui-common';
import { TextField, Typography } from '@mui/material';

type Scenario = 'copy' | 'link-sync' | 'link-independent';

interface ZoneWizardStep3Props {
    sourceZoneName: string;
    value: string;
    onChange: (name: string) => void;
    existingNames: string[];
    scenario: Scenario;
}

function ZoneWizardStep3({ sourceZoneName, value, onChange, existingNames, scenario }: ZoneWizardStep3Props) {
    React.useEffect(() => {
        if (existingNames.length > 0 && !value) {
            const suffix = scenario === 'copy' ? 'Copy' : 'Link';
            onChange(generateUniqueName(sourceZoneName, existingNames, suffix));
        }
    }, [existingNames, scenario, onChange, sourceZoneName, value]);

    const trimmed = value.trim();
    const isDuplicate = trimmed.length > 0 && existingNames.length > 0 && existingNames.includes(trimmed);
    let description = i18n('copy_zone_step3_description');
    if (scenario === 'link-sync') {
        description = i18n('copy_zone_link_sync_step3_description');
    } else if (scenario === 'link-independent') {
        description = i18n('copy_zone_link_independent_step3_description');
    }

    return (
        <>
            <Typography paragraph>{description}</Typography>
            <TextField
                label={i18n('copy_zone_step3_name_label') as string}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                fullWidth
                required
                autoFocus
                error={isDuplicate}
                helperText={isDuplicate ? (i18n('the_name_should_be_unique_X_is_already_used', trimmed) as string) : undefined}
            />
        </>
    );
}

export default ZoneWizardStep3;
